module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "chaptitle"
  }, [_vm._v("Century Club, New York City, 2001")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“That’s an odd reference,” I said. “O. Henry. ‘The Gift of the Magi.’ Are you religious?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Not then or now,” Danforth answered. “But we lived in a culturally coherent world, Clayton and I, a world of shared symbols and references. Old Testament. New Testament.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A coherence our current enemies now have in abundance,” I added coldly. “But which we have somewhat lost.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Danforth shrugged. “True enough, but would you want it back if you got the Duke of Alva with it too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had no idea who the Duke of Alva was but saw no need to demonstrate that lack of familiarity, and so I said, “Meaning what?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That it’s easy to become what you once abhorred,” Danforth answered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("This struck me as rather windy, and probably a quote. I returned to the more relevant subject at hand. “So, Clayton had made his proposal,” I said. “What did you do then?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Despite the snow, I started walking uptown,” Danforth answered. “On the way, I thought about the young woman, about what she was willing to do. And I thought about myself. I even thought about O. Henry. I was still turning all that over in my mind when I got to the Plaza.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60aba81a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/11_Pt1Ch7.vue
// module id = 99
// module chunks = 0